import React from 'react';

class MovieSlider extends React.Component {
  constructor(props) {
    super(props)
    this.bgImage = this.bgImage.bind(this)
    this.readableDuration = this.readableDuration.bind(this)
    this.openTrailer = this.openTrailer.bind(this)
  }

  bgImage() {
    let obj = {}
    let uri = ""
    if (this.props.film.mobPoster) {
      uri = this.props.film.mobPoster
    } else if (this.props.film.bgPoster) {
      uri = this.props.film.bgPoster
    } else {
      uri = '/img/logo/logo.svg'
      obj.backgroundSize = '50%'
    }
    obj.backgroundImage = "url(" + uri + ")"
    return obj
  }

  readableDuration(mins) {
    let hrsString = mins > 60 ? Math.floor(mins / 60).toString() + " год " : ""
    let minsString = mins % 60 + " хв."
    return hrsString + minsString

  }

  openTrailer() {
    this.props.openTrailer(this.props.film.Id)
  }

  render() {
    return (
      <div className="mvi__slider" style={this.bgImage()}>
        <div className="mvi__slider__mask">
          <div className="wd">
            {this.props.film.TrailerUrl && <img src="/img/ic_play.svg" className="mvi__slider__trailer" alt="" onClick={() => { this.openTrailer() }} />}
            <div className="mvi__slider__content">
              <h1 className="mvi__slider__heading">{this.props.film.Name}</h1>
              <div className="mvi__slider__meta">
                {this.props.film.duration && <p className="tag">{this.readableDuration(this.props.film.duration)}</p>}
                {this.props.film.Rating && <p className="tag">{this.props.film.Rating}</p>}
                {this.props.film.mov_rate.imdb && <p className="rating"><img src="/img/ic_star.svg" alt="" />{this.props.film.mov_rate.imdb} IMDB</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MovieSlider


// WEBPACK FOOTER //
// ./src/components/pages/MoviePage/impl/MoviePageSlider.jsx